// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StarPlayersCheck_wrapper__3XojQ"};